export default __webpack_public_path__ + "static/media/966DDEAC-D5DF-405D-B340-D61B162FC358_1_105_c.dd63c4db.jpeg";